import { ApiModels } from '@mona/api';
import { MonaNotification } from '@mona/models';

/**
 * Transforms API notification
 *
 * @param apiNotification ApiModels.Notification
 */
export const transformApiNotification = (apiNotification: ApiModels.Notification): MonaNotification => {
    return {
        id: apiNotification.id,
        encounterId: apiNotification.encounter_id,
        source: apiNotification.source,
        title: apiNotification.title,
        body: apiNotification.body,
        navigateTo: apiNotification.navigate_to,
        subTitle: apiNotification.sub_title,
        readStatus: apiNotification.read_status,
        readBy: apiNotification.read_by,
        imgUrl: apiNotification.img_url,
        aiSource: apiNotification.ai_source,
        aiReason: apiNotification.ai_reason,
        feedbackUrl: apiNotification.feedback_url,
        isAi: apiNotification.is_ai,
        createdAt: apiNotification.created_at,
        updatedAt: apiNotification.updated_at,
    };
};

/**
 * Transforms API notification
 *
 * @param apiNotifications ApiModels.Notification[]
 */
export const transformApiNotifications = (apiNotifications: ApiModels.Notification[]): MonaNotification[] => {
    return apiNotifications.map(apiNotification => transformApiNotification(apiNotification));
};
